import React from 'react';
import { Skeleton } from 'antd';

import { VideoPlayer } from '@/components/ui/@DesignSystem/VideoPlayer';
import { useBeraReportV2 } from '@/context/BeraReportV2';

import { PlayerPlaceholder } from './styles';

export type PlayerProgress = {
	played: number;
	playedSeconds: number;
};

const STRETCH_PROGRESS_INTERVAL_IN_MILLISECONDS = 100;

interface PlayerProps {
	onProgress: (progress: PlayerProgress) => void;
	onClose: () => void;
}

export function Player({ onProgress, onClose }: Readonly<PlayerProps>): JSX.Element {
	const { videoUrl, playerRef, onVideoDurationChange } = useBeraReportV2();

	if (!videoUrl) {
		return (
			<PlayerPlaceholder>
				<Skeleton active title={false} paragraph={{ rows: 4 }} />
			</PlayerPlaceholder>
		);
	}

	return (
		<VideoPlayer
			showVolume={false}
			showMinimize
			showCloseButton
			src={videoUrl}
			playerRef={playerRef}
			onProgress={onProgress}
			progressInterval={STRETCH_PROGRESS_INTERVAL_IN_MILLISECONDS}
			onDurationChange={onVideoDurationChange}
			onClose={onClose}
		/>
	);
}
